import { Section } from 'components/Section';
import { BhImage } from 'models/BhImage';
import { Grid, Cell } from 'components/Grid';
import Image from 'components/Shared/Image';
import styles from './imageGallery.scss';
import { useState } from 'react';
import cn from 'classnames';
import { rm } from 'utils';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import ResponsiveImage from 'components/Shared/Image/ResponsiveImage';

interface OwnProps {
  images: BhImage[];
}

const DEFAULT_SECTION_IMAGE = 365;

const customSizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: DEFAULT_SECTION_IMAGE,
    width: DEFAULT_SECTION_IMAGE,
    height: DEFAULT_SECTION_IMAGE
  }
};

const responsive: ResponsiveImage = {
  srcSet: Object.values(customSizes),
  sizes: `${customSizes.default.width}px`
};

type AnimationType = 'in' | 'out';
const GalleryItem = (props: BhImage) => {
  const [animationType, setAnimationType] = useState<AnimationType | undefined>();
  const _setAnimationType = (type: AnimationType) => () => setAnimationType(type);
  return (
    <Cell
      onMouseOver={_setAnimationType('in')}
      onMouseOut={_setAnimationType('out')}
      className={cn(styles.galleryItem, {
        [styles.zoomIn]: animationType === 'in',
        [styles.zoomOut]: animationType === 'out'
      })}
    >
      <Image
        {...props}
        paddingBottom
        width={DEFAULT_SECTION_IMAGE}
        height={DEFAULT_SECTION_IMAGE}
        responsive={responsive}
      />
    </Cell>
  );
};

export const ImageGallery = ({ images }: OwnProps) => (
  <Section title={rm('brad_page_gallery_title')} className={styles.gallery}>
    <Grid gutters="medium" tablet="5">
      {images.map(image => image && <GalleryItem key={image.id} {...image} />)}
    </Grid>
  </Section>
);
